import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, TipoAditivo, } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class TipoAditivoService extends BaseResourceService<TipoAditivo> {

  constructor(
    protected injector: Injector
  ) {
    super(`tipo-aditivos`, injector);
  }

}
